import { gsap } from 'gsap';

export const snapper = (increment: number) => {
  return gsap.utils.snap(increment);
};
